const configLiveKlass = {
  liveKlass: {
    listLayout: "LiveKlassListDefaultLayout",
    filterLayout: "LiveKlassFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getLiveKlass",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      obt: 'created_at',
      obs: 'desc',
    },
  },
  liveKlassDetail: {
    writeLayouts: ["LiveKlassWriteDefaultLayout"],
    getFunc: "getLiveKlass",
    detailApiParamsSet: {ip: 0},
    getDetailParamsKey: "id",
    writeFunc: "updateLiveKlass",
    writeApiParamSet: {
    },
    parsingData: {
      title: 'lk_title',
      subTitle: 'lk_sub_title',
      koin: 'lk_koin_price',
      info: 'lk_info',
      mcName: 'lk_mc_name',
      mcIdx: 'mb_no',
      seq: 'lk_seq',
      url: 'lk_url',
    },
    directUrl: "/content/liveklass",
    directType: "",
    fileType: "live_klass",
    keyName: "lk_idx",
    writeSuccessType: 1,
    writeFailTypes: {
      '-107': "동일한 진행자명이 존재합니다.",
      '-108': "이미 등록된 샘샘즈입니다.",
      '-109': "미사용중인 샘샘즈입니다."
    },
    deleteFunc: 'deleteLiveKlass',
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteAlertText:"정말 삭제 하시겠습니까?<br>삭제 후 기록 복구가 불가능합니다.",
    deleteSuccessAlertText: "삭제되었습니다.",
    deleteFailTypes: {
      '-2': "삭제된 라이브 클래스입니다.",
      '-107': "동일한 진행자명이 존재합니다.",
      '-103': "해당 진행자가 진행중이거나 시작 예정인<br> 스트리밍이 있어 삭제 불가합니다."
    },
  },
  liveKlassCreate: {
    writeLayouts: ["LiveKlassWriteDefaultLayout"],
    getFunc: "getLiveKlass",
    detailApiParamsSet: {ip: 0},
    getDetailParamsKey: "id",
    writeFunc: "createLiveKlass",
    writeApiParamSet: {
    },
    parsingData: {
      title: 'lk_title',
      subTitle: 'lk_sub_title',
      mcName: 'lk_mc_name',
      koin: 'lk_koin_price',
      info: 'lk_info',
      mcIdx: 'mb_no',
      seq: 'lk_seq',
      url: 'lk_url',
    },
    directUrl: "",
    directType: "",
    fileType: "live_klass",
    keyName: "lk_idx",
    writeSuccessType: 1,
    writeFailTypes: {
      '-107': "동일한 진행자명이 존재합니다.",
      '-108': "이미 등록된 샘샘즈입니다.",
      '-109': "미사용중인 샘샘즈입니다."
},
  },
  liveKlassStreaming: {
    listLayout: "LiveKlassListStreamingLayout",
    filterLayout: "LiveKlassFilterStreamingLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getStreaming",
    listApiParamSet: {
      ip: 1,
      sp: 10,
    },
    keyName: 'lkid',
  },
  adjust: {
    listLayout: "LiveKlassListAdjustLayout",
    filterLayout: "LiveKlassFilterAdjustLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getAdjust",
    listApiParamSet: {
      ip: 1,
      sp: 10,
    },
  },
  adjustDetail: {
    listLayout: "LiveKlassListAdjustDetailLayout",
    filterLayout: "LiveKlassFilterAdjustDetailLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getAdjustDetail",
    listApiParamSet: {
      ip: 1,
      sp: 10,
    },
  },
}

export default {
  methods: {
    returnLiveKlassConfig(type) {
      return configLiveKlass[type];
    },
  },
  filterConfig: {
    cr: {
      type: 'between',
      classname: 'filterDate'
    },
    mc: {
      type: 'query',
      classname: 'searchInput',
    },
    ti: {
      type: 'query',
      classname: 'searchInput',
    },
    sl: {
      type: 'between',
      classname: 'filterStartDate'
    },
    st: {
      type: 'match',
      classname: 'filterStatus'
    },
    sr: {
      type: 'between',
      classname: 'filterDate'
    },
    sti: {
      type: 'query',
      classname: 'searchInput',
    },
    pst: {
      type: 'match',
      classname: 'filterStatus'
    },
    pr: {
      type: 'between',
      classname: 'filterDate'
    },
    ni: {
      type: 'query',
      classname: 'searchInput',
    },
  }
}
